import { render } from "./InformationForm.vue?vue&type=template&id=3a5b02b5&scoped=true"
import script from "./InformationForm.vue?vue&type=script&lang=js"
export * from "./InformationForm.vue?vue&type=script&lang=js"

import "./InformationForm.vue?vue&type=style&index=0&id=3a5b02b5&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\runpixie_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a5b02b5"]])

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner,QBtn,QSelect,QInput,QField});
